module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) { fox.registerWidget('SitePage_Sponsor', {
	configure: function () {

		this.registerOptions('', {
			widgets: {
				crowdFunding: {
					widget: 'CrowdFunding',
					'widgets.banner.embed.container': '.sponsor-page'
				}
			}
			
		});

		this.callParent('configure', arguments);
	}
}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/sponsor.js
// module id = 934
// module chunks = 4